import { CreateCountyRecordInput, UpdateCountyRecordInput } from 'src/app/services/API.service';
import { NoteProfile } from './noteProfile';
import { Party } from './party';
import { Link } from './link';
import { SearchMatch } from './searchMatch';
import { UserData } from './userData';

export class CountyRecord {
    id: string;
    pKey: string;
    sKey: string;
    key: string;
    RecordNumber: string = null;
    RecordDate: string;
    RecordDateDisp: string = null;
    Amount: string = null;
    Book: string = null;
    BookType: string = null;
    CaseNumbers: string[];
    Comments: string;
    Description: string = null;
    DocType: string = null;
    Page: string = null;
    PageCount:string = null;
    PartiesDisp: string = null;
    FromDisp: string = null;
    ToDisp: string = null;
    ToParties: string[] = [];
    FromParties: string[] = [];
    createdAt: Date;
    updatedAt: Date;
    UpdatedDisp: string = null;
    NoteProfile: NoteProfile;
    Links: Link[] = [];
    Score: number = 0;
    SearchMatches: SearchMatch[] = [];
    Satisfactions: SearchMatch[] = [];
    Exclude: boolean;
    UpdateList: string[] = [];
    UserData: UserData;
    Status: string = '';
    ExcludeList: string[] = [];

    constructor(data?) {
        if (data) {

            this.id = data.id;
            this.pKey = data.pKey;
            this.sKey = data.sKey;
            this.key = '';
            this.createdAt = new Date(data.createdAt);
            this.updatedAt = new Date(data.updatedAt);
            this.UpdatedDisp = this.updatedAt.toISOString().substring(0, 10)
    
            this.RecordNumber = data.RecordNumber;
            this.RecordDate = data.RecordDate;

            const d = (new Date(this.RecordDate)).toLocaleDateString().split('/');
            this.RecordDateDisp = d[2] + '-' + d[0].padStart(2, '0') + '-' + d[1].padStart(2, '0');
    
            this.ToParties = data.ToParty;
            this.FromParties = data.FromParty;

            if (data.Exclude) {
                this.ExcludeList = data.Exclude;
            }

            if (data.SearchMatches.length > 0 && data.SearchMatches[0]['Score']){
                this.Score = data.SearchMatches[0]['Score'];   
            }

            if (data.SearchMatches) {
                data.SearchMatches.forEach(e => {
                    this.SearchMatches.push(new SearchMatch(e));
                });
            }

            if (data.Satisfactions) {
                data.Satisfactions.forEach(e => {
                    this.Satisfactions.push(new SearchMatch(e));
                });
            }
    
            data.links.forEach(e => {
                this.Links.push(new Link(e));
            });
    
            if (data.Amount) {
                this.Amount = data.Amount;
            }
    
            if (data.Book) {
                this.Book = data.Book;
            }
    
            if (data.BookType) {
                this.BookType = data.BookType;
            }
    
            if (data.CaseNumber) {
                this.CaseNumbers = data.CaseNumber;
            }
    
            if (data.Comments) {
                this.Comments = data.Comments;
            }
    
            if (data.Description) {
                this.Description = data.Description;
            }
    
            if (data.DocType) {
                this.DocType = data.DocType;
            }
    
            if (data.Page) {
                this.Page = data.Page;
            }
    
            if (data.PageCount) {
                this.PageCount = data.PageCount;
            }

            if (data.UserData && data.UserData.items.length > 0) {
                this.UserData = new UserData(data.UserData.items[0]);
            } else {
                this.UserData = new UserData();
            }

        }
    }

    addProfile(data: NoteProfile) {
        const i = this.UserData.Note.get('Selected').value;

        this.NoteProfile = data;

        const stat = data.DropdownEntries.filter(n => n.value == i);

        if (stat.length > 0) {
            this.Status = stat[0].text;
        }

    }

    RecordInput() {
        const d = (new Date(this.RecordDate)).toLocaleDateString().split('/');
        const date = d[2] + '-' + d[0].padStart(2, '0') + '-' + d[1].padStart(2, '0');
        const rec: CreateCountyRecordInput = {
            pKey: this.pKey,
            sKey: this.sKey,
            searchTxt: this.FromParties.join(',')
        };

        // rec.keyType = this.key;
        rec.Date = date;
        rec.RecordDate = this.RecordDate;
        rec.RecordNumber = this.RecordNumber;
        rec.BookType = this.BookType;
        rec.Book = this.Book;
        rec.Page = this.Page;
        rec.PageCount = this.PageCount;
        rec.DocType = this.DocType;
        rec.CaseNumber = this.CaseNumbers;
        rec.Amount = this.Amount;
        rec.FromParty = this.FromParties;
        rec.ToParty = this.ToParties;
        rec.links = [];
        // rec.searchTxt = this.FromParties.join(',') + ',' + this.RecordNumber;

        this.Links.forEach(n => {
            rec.links.push({
                LinkType: n.Type,
                LinkText: n.LinkText
            });
        });

        return rec;
    }

    RecordUpdate() {
        const rec: UpdateCountyRecordInput = {
            id: '',
            pKey: '',
            sKey: this.key,
            RecordNumber: this.RecordNumber,
            searchTxt: this.FromParties.join(',') + ',' + this.RecordNumber 
        };

        this.Links.forEach(n => {
            rec.links.push({
                LinkType: n.Type,
                LinkText: n.LinkText
            });
        });

        return rec;
    }

    parseCSV(data) {
        const rec = data.split(',');
        const d = (new Date(rec[1].replace(String.fromCharCode(10), ''))).toLocaleDateString().split('/');
        const date = d[2] + '-' + d[0].padStart(2, '0') + '-' + d[1].padStart(2, '0');

        this.pKey = 'FL-Collier-Deed';
        this.sKey = date + '-' + rec[3];

        this.key = 'FL-Collier-Deed';
        // this.key = 'FL-Collier-Deed';
        this.RecordDate = rec[1].replace(String.fromCharCode(10), '');
        this.RecordNumber = rec[3];
        this.BookType = rec[4].trim().split(' ')[0];
        this.Book = rec[4].trim().split(' ')[1];
        this.Page = rec[5];
        this.PageCount = rec[6];
        this.DocType = rec[2];
        this.Description = rec[7].split('~').join(', ');

        const parties = rec[0].split('~');

        parties.forEach(e => {
            switch (e.trim().substring(0, 1)) {
                case 'F':
                    this.FromParties.push(e.replace('F:', '').replace(String.fromCharCode(10), '').replace(String.fromCharCode(13), ''));
                    break;
                case 'T':
                    this.ToParties.push(e.replace('T:', '').replace(String.fromCharCode(10), '').replace(String.fromCharCode(13), ''));
                    break;
            
                default:
                    break;
            }
        });

        if (rec[9]) {
            this.Links.push(new Link({
                LinkType: 'PDF Document',
                LinkText: rec[9]
            }));
        }
      
        if (rec[10]) {
            this.Links.push(new Link({
                LinkType: 'View Detail',
                LinkText: rec[10]
            }));
        }
    
        if (rec[11]) {
            this.Links.push(new Link({
                LinkType: 'Affected Documents',
                LinkText: rec[11]
            }));
        }

    }
}
